import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
    SortInfo,
    creationDateDescSortInfo
} from '../../../overviews/generic-overview/components/display-settings-bar/entities/sort-info.entity';
import { BaseService } from '../../common/services/base.abstract.service';
import { CustomHttpParamEncoder } from '../../http/entities/custom-http-param-encoder';
import { ShPaginationService } from '../../http/services/pagination.service';
import { RecordId } from '../../records/entities/metadata/metadata.entity';
import { ApiJob } from '../entities/api-job.entity';

@Injectable({ providedIn: 'root' })
export class JobsDataService extends BaseService {
    constructor(private readonly paginationService: ShPaginationService) {
        super();
    }

    private readonly jobsEndpoint: string = `v2/jobs`;

    // Gets all failed jobs of record
    public getAllRecordJobs(recordId: RecordId, sortInfo: SortInfo = creationDateDescSortInfo): Observable<ApiJob[]> {
        const params: HttpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() })
            .set('RecordId', recordId)
            .set('sort', sortInfo.field)
            .set('direction', sortInfo.direction);

        const request = `${this.jobsEndpoint}`;

        return this.paginationService.getAll(request, params);
    }

    public getAllBatchJobs(batchId: string): Observable<ApiJob[]> {
        const params: HttpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() }).set('BatchId', batchId);
        const request: string = this.jobsEndpoint;

        return this.paginationService.getAll<ApiJob>(request, params);
    }
}
